import React from "react";

import classnames from "classnames";
import formatCurrency from "Utils/formatCurrency";

import { enrollmentForOverview, chooseCoverageRows } from "../Utils/chooseCoverage";
import { TitleSmall } from "Cobalt/Header";
import Button from "Common/Button";
import InfoPopover from "Common/InfoPopover";
import { DISPLAY_CATEGORIES, DISPLAY_TERM_NAMES } from "Common/plans/VisionPlanDetails";
import { ContentRow } from "Common/Table";
import BodyText from "Theme/BodyText";

import makeBem from "Utils/makeBem";

const bem = makeBem("MultipleMedicalPlans");

const pricingTable = (prices, contributions, familyInfo, plans) =>
  chooseCoverageRows(familyInfo, prices, contributions, enrollmentForOverview(prices, familyInfo), "vision").map((row) => (
    <ContentRow
      heading={<BodyText>{row.label}</BodyText>}
      key={row.rowId}
      className={classnames(bem("specificCostRow"))}
      cell={(_, i) => <>{formatCurrency(row.prices[i])}/mo</>}
      items={plans}
    />
  ));

const YourCostCell = () => (
  <span>
    <strong>Your Cost</strong>
    <InfoPopover infoTitle="Payroll Contributions" infoText="This is the amount you pay each month, taken directly out of your paycheck." placement="top" />
  </span>
);

const MultipleVisionPlans = ({ prices, contributions, familyInfo, plans, onClick }) => (
  <>
    <tbody>
      <ContentRow
        cell={YourCostCell}
        heading={
          <TitleSmall mt={0} mb={0}>
            Premium Overview
          </TitleSmall>
        }
        className={classnames(bem("payrollContributonHeaderRow"), "bg-gray-100")}
        items={plans}
      />
      {pricingTable(prices, contributions, familyInfo, plans)}

      <ContentRow
        cell={(p) => (
          <Button
            text="Enroll or Decline"
            color="blue"
            size="medium"
            fullWidth
            className={classnames(bem("selectPlanButton"))}
            data-keyboard="true"
            onClick={(_) => onClick(p.id)}
          />
        )}
        items={plans}
      />
      <ContentRow
        heading={
          <TitleSmall mt={0} mb={0}>
            Plan Overview
          </TitleSmall>
        }
        className="row-separator bg-gray-100"
        cell={(p) => ""}
        items={plans}
      />
      <ContentRow heading={<BodyText weight="bold">Eye Exam</BodyText>} className="row-separator" cell={(p) => p.eye_exam} items={plans} />
      <ContentRow
        heading={<BodyText weight="bold">Eyeglass Lenses</BodyText>}
        className="row-separator"
        cell={(p) => <span dangerouslySetInnerHTML={{ __html: p.lenses }} />}
        items={plans}
      />
      <ContentRow heading={<BodyText weight="bold">Eyeglass Frames</BodyText>} className="row-separator" cell={(p) => p.frames} items={plans} />
      <ContentRow
        heading={<BodyText weight="bold">Contact Lenses</BodyText>}
        className="row-separator"
        cell={(p) => <span dangerouslySetInnerHTML={{ __html: p.contacts }} />}
        items={plans}
      />

      <ContentRow
        heading={
          <TitleSmall mt={0} mb={0}>
            Plan Details
          </TitleSmall>
        }
        className="row-separator bg-gray-100"
        cell={(p) => ""}
        items={plans}
      />

      <ContentRow heading={<BodyText weight="bold">Basic</BodyText>} className="row-separator" cell={(p) => ""} items={plans} />
      {DISPLAY_CATEGORIES.Basic.map((term) => (
        <ContentRow
          heading={<BodyText ml={2}>{DISPLAY_TERM_NAMES[term] || term}</BodyText>}
          className="row-separator"
          cell={(p) => p.fine_print.Basic[term].inNetwork}
          items={plans}
        />
      ))}

      <ContentRow heading={<BodyText weight="bold">Eyeglass Lenses</BodyText>} className="row-separator" cell={(p) => ""} items={plans} />
      {DISPLAY_CATEGORIES["Eyeglass Lenses"].map((term) => (
        <ContentRow
          heading={<BodyText ml={2}>{DISPLAY_TERM_NAMES[term] || term}</BodyText>}
          className="row-separator"
          cell={(p) => p.fine_print["Eyeglass Lenses"][term].inNetwork}
          items={plans}
        />
      ))}

      <ContentRow heading={<BodyText weight="bold">Frames</BodyText>} className="row-separator" cell={(p) => ""} items={plans} />
      {DISPLAY_CATEGORIES.Frames.map((term) => (
        <ContentRow
          heading={
            <BodyText ml={2}>
              {(DISPLAY_TERM_NAMES[term] || term).split("<br>").map((text, index) => (
                <React.Fragment key={index}>
                  {index !== 0 && <br />}
                  {text}
                </React.Fragment>
              ))}
            </BodyText>
          }
          className="row-separator"
          cell={(p) => p.fine_print.Frames[term].inNetwork}
          items={plans}
        />
      ))}

      <ContentRow heading={<BodyText weight="bold">Contact Lenses</BodyText>} className="row-separator" cell={(p) => ""} items={plans} />
      {DISPLAY_CATEGORIES["Contact Lenses"].map((term) => (
        <ContentRow
          heading={<BodyText ml={2}>{DISPLAY_TERM_NAMES[term] || term}</BodyText>}
          className="row-separator"
          cell={(p) => p.fine_print["Contact Lenses"][term].inNetwork}
          items={plans}
        />
      ))}
    </tbody>
    <ContentRow
      cell={(p) => (
        <Button
          text="Enroll or Decline"
          size="medium"
          fullWidth
          className={classnames(bem("selectPlanButton"))}
          data-keyboard="true"
          onClick={(_) => onClick(p.id)}
        />
      )}
      items={plans}
    />
  </>
);

export default MultipleVisionPlans;
